import styled, { css } from 'styled-components';
var StyledIcon = styled.svg.withConfig({
  displayName: "StyledIcon",
  componentId: "sc-1ch6fwv-0"
})(["", ""], function (_ref) {
  var fill = _ref.fill,
    notChangeable = _ref.notChangeable;
  return !notChangeable && css(["fill:", ";path,> rect{fill:", ";}"], function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors[fill] ? theme.colors[fill] : fill;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors[fill] ? theme.colors[fill] : fill;
  });
});
export { StyledIcon };